import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class InvoiceInfoService {

    readonly apiPath = environment.baseUrl + 'invoice-info/';
    readonly headers = { headers: new HttpHeaders({ 'No-Auth': 'True' }) };
    constructor(
        private http: HttpClient,
    ) { }

    getInvoiceAmount(invoiceNumber: string): Observable<number> {
        return this.http.get(this.apiPath+ 'get-amount/' + invoiceNumber, {  }) as Observable<number>;
    }
    getInvoiceAmountOutstanding(invoiceNumber: string): Observable<number> {
        return this.http.get(this.apiPath+ 'get-amount-outstanding/' + invoiceNumber, {  }) as Observable<number>;
    }

  getLinkTokengByProtectedCodeIfPaid(protectedCode: string): Observable<string> {
    return this.http.get(this.apiPath+ 'get-token-for-upload-doc/' + protectedCode, {  }) as Observable<string>;
  }

  /*
    getStripePublishableKey(): Observable<string> {
      return this.http.get(this.apiPath+ "stripe-pk", {  }) as Observable<string>;
    }
   */

  getStripePublishableKey(item): Observable<Object> {
    return this.http.post(this.apiPath + 'stripe-pk', item) as Observable<Object>;
  }
}
